import React from 'react';
import mergeClassnames from '../../mergeClassnames/mergeClassnames';
const Hover = ({ isHover, variant, }) => {
    const hoverBackground = variant === 'ghost' ? 'bg-jiren' : 'bg-heles';
    return (React.createElement("span", { "aria-hidden": "true", className: mergeClassnames('z-[-1] block absolute inset-0 pointer-events-none', 'transition-[background-color_0.2s_ease-in-out]', isHover && hoverBackground) }));
};
export default Hover;
